var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-container o-container--thin onboarding-page"},[_c('onboarding-form',{attrs:{"user":_vm.user}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }